$(function() {
  clampLines();
});

$(document).ready(function () {
  $(document).ajaxStop(function () {
    $("span.clamp-lines").on("click", function(e) {
      var description = $(this).parent().children('.description');
      var contentHeight = description.children('.inner').height() + description.children('.neos-contentcollection').height();
      
      description.toggleClass('collapsed').promise().done(function(){
        if(!description.hasClass('collapsed')) description.css('max-height', contentHeight + 'px');
        else description.css('max-height', '120px');
      });
      $(this).toggleClass('less');
    });
  });
});

function clampLines() {
  $("span.clamp-lines").each(function() {
    var description = $(this).parent().children('.description');
    var contentHeight = description.children('.inner').height() + description.children('.neos-contentcollection').height();

    hasForm = ((description.find('.obisconcept-neosajaxform-ajaxform').length)? true : false);
    
    if(contentHeight < 160 && !hasForm) {
      $(this).css('display','none');
      description.removeClass('collapsed');
      description.css('transition-duration',contentHeight/1000 + 's');
    }
  });
}